














import { Component, Prop, Vue } from 'vue-property-decorator'
import { EventBus } from './EventBus'
import { namespace } from 'vuex-class'
const ui = namespace('ui')

@Component
export default class Collapsable extends Vue {
    @ui.State collapsableActive: boolean
    @ui.Action toggleCollapsableActive: ({ active: boolean} ) => Promise<void>
    @Prop({ required: true }) readonly className!: string
    activeClass: string = ''
    throttleFalse = null
    throttleRetry = null

    mounted() {
        EventBus.$on('close', this.onClose)
    }

    onClose() {
        this.toggleClass(false, 'content')
    }

    toggleClass(toggle: boolean = true, source: 'clickable'|'content' = 'clickable'): void {
        clearTimeout(this.throttleFalse)
        clearTimeout(this.throttleRetry)
        this.throttleFalse = null
        this.throttleRetry = null

        if (this.collapsableActive && toggle) {
            this.throttleRetry = setTimeout(() => {
                this.toggleClass(toggle, source)
            }, 100)
            return
        }

        if (toggle && !(source === 'content' && !this.isActive)) {
            this.activeClass = this.className
            this.toggleCollapsableActive({ active: true })
        } else {
            this.throttleFalse = setTimeout(() => {
                this.activeClass = ''
                this.toggleCollapsableActive({ active: false })
            }, 300)
        }
    }

    get isActive(): boolean {
        return this.activeClass === this.className
    }
}

